import React, { useEffect, useState } from 'react';
import axios from 'axios';
import ProductCard from '@/components/ProductCard';
import SectionHeader from '@/components/SectionHeader';
import Spinner from '@/components/Spinner';
import { API } from '@/lib/utils';
import { useSEO } from '@/lib/useSEO';

export default function BestBuys() {
  const [products, setProducts] = useState(null);
  useSEO({
    title: 'Beste keuzes 2026',
    description: 'Onze redactioneel geselecteerde beste producten voor een noodpakket in 2026. Onafhankelijk vergeleken op basis van reviews, specs en praktijktesten.',
    path: '/beste-keuzes',
  });
  useEffect(() => {
    axios.get(`${API}/products?best_buy=true&limit=100`).then((r) => setProducts(Array.isArray(r.data) ? r.data : [])).catch(console.error);
  }, []);
  return (
    <div data-testid="page-best-buys">
      <section className="border-b border-border bg-card">
        <div className="container py-16 lg:py-24">
          <SectionHeader
            eyebrow="Beste keuzes 2026"
            title="Onze onafhankelijke aanbevelingen"
            description="Redactioneel geselecteerd op basis van reviews, specificaties en ervaringen van hulporganisaties. Geen sponsoring — puur kwaliteit."
            accent
          />
        </div>
      </section>
      <section className="container py-12 lg:py-16">
        {products === null ? <Spinner /> : (
          <div className="grid grid-cols-2 lg:grid-cols-4 gap-5">
            {(products || []).map((p, i) => <ProductCard key={p.slug} product={p} index={i} />)}
          </div>
        )}
      </section>
    </div>
  );
}
